export const environment = {
  production: true,
  appVersion: require('../../package.json').version + '-devessp',
  appName: require('../../package.json').name,
  appPrefix: 'salesnav',

  salesNavBackendUrl: 'https://essp-api-besalesnavigator-dev.acp-gruppe.com',
  portalMetaBackendUrl: 'https://essp-api-beportalmetadata-dev.acp-gruppe.com',
  portalHomeUrl: 'https://essp-dev.acp-gruppe.com',
  successNavigatorUrl: 'https://essp-success-navigator-dev.acp-gruppe.com',
  partnerNavigatorUrl: 'https://essp-partnernavigator-dev.acp-gruppe.com',
  stage: 'dev',

  issuer: 'https://ciam-dev.acp-gruppe.com',
  tokenEndpoint: 'https://ciam-dev.acp-gruppe.com/token-srv/token',
  clientId: 'cc8fd426-0a99-452d-afb7-5d421ee01d2b',
  scope: 'openid profile roles groups acpprofile offline_access',
};
